import React, { useState } from 'react';
import AppHeader from '../components/layout/AppHeader';

const ContactUs: React.FC = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        // Here you would typically integrate with a backend or Formspree
        console.log('Form submitted:', formData);
        setSubmitted(true);
    };

    return (
        <div className="min-h-screen bg-premium-wood-dark text-white font-sans">
            {/* Reusing AppHeader for consistency if logged in, but for public pages typically we might want a simpler header or the same one. 
                 Since AppHeader handles auth state, it's safe to use. */}
            <AppHeader title="Contact Us" />

            <main className="container mx-auto px-4 py-12">
                <div className="max-w-4xl mx-auto">
                    <div className="text-center mb-16">
                        <h1 className="text-4xl md:text-5xl font-serif font-bold text-premium-gold mb-6">
                            Get in Touch
                        </h1>
                        <p className="text-xl text-white/80 max-w-2xl mx-auto">
                            Have questions about joining TechUnity Global? Need support?
                            We're here to help you navigate your journey to self-employment.
                        </p>
                    </div>

                    <div className="grid md:grid-cols-2 gap-12">
                        {/* Contact Info */}
                        <div className="space-y-8">
                            <div className="bg-black/20 backdrop-blur-sm border border-premium-gold/20 p-8 rounded-xl">
                                <h3 className="text-2xl font-bold text-premium-gold mb-4">Support & Inquiries</h3>
                                <p className="text-white/70 mb-6">
                                    Our team is dedicated to supporting the global workforce. Reach out to us directly.
                                </p>
                                <div className="space-y-4">
                                    <div className="flex items-start gap-4">
                                        <div className="w-10 h-10 rounded-full bg-premium-gold/10 flex items-center justify-center text-premium-gold shrink-0">
                                            ✉️
                                        </div>
                                        <div>
                                            <p className="font-bold text-white">Email Us</p>
                                            <a href="mailto:support@techunityglobal.com" className="text-premium-gold hover:underline">
                                                support@techunityglobal.com
                                            </a>
                                        </div>
                                    </div>
                                    <div className="flex items-start gap-4">
                                        <div className="w-10 h-10 rounded-full bg-premium-gold/10 flex items-center justify-center text-premium-gold shrink-0">
                                            🌍
                                        </div>
                                        <div>
                                            <p className="font-bold text-white">Global Headquarters</p>
                                            <p className="text-white/70">Virtual Office (Global)<br />Accessible from Anywhere</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Contact Form */}
                        <div className="bg-white/5 backdrop-blur-md border border-premium-gold/30 p-8 rounded-xl shadow-[0_0_50px_rgba(212,175,55,0.1)]">
                            {submitted ? (
                                <div className="text-center py-12">
                                    <div className="text-5xl mb-4">✅</div>
                                    <h3 className="text-2xl font-bold text-premium-gold mb-2">Message Sent!</h3>
                                    <p className="text-white/70">Thank you for reaching out. Our support team will get back to you shortly.</p>
                                    <button
                                        onClick={() => setSubmitted(false)}
                                        className="mt-6 px-6 py-2 text-sm text-premium-gold border border-premium-gold/30 rounded hover:bg-premium-gold/10 transition-colors"
                                    >
                                        Send another message
                                    </button>
                                </div>
                            ) : (
                                <form onSubmit={handleSubmit} className="space-y-6">
                                    <div>
                                        <label htmlFor="name" className="block text-sm font-medium text-white/80 mb-2">Full Name</label>
                                        <input
                                            type="text"
                                            id="name"
                                            required
                                            className="w-full bg-black/40 border border-white/10 rounded-lg px-4 py-3 text-white placeholder-white/30 focus:outline-none focus:border-premium-gold transition-colors"
                                            placeholder="John Doe"
                                            value={formData.name}
                                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="email" className="block text-sm font-medium text-white/80 mb-2">Email Address</label>
                                        <input
                                            type="email"
                                            id="email"
                                            required
                                            className="w-full bg-black/40 border border-white/10 rounded-lg px-4 py-3 text-white placeholder-white/30 focus:outline-none focus:border-premium-gold transition-colors"
                                            placeholder="you@example.com"
                                            value={formData.email}
                                            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="message" className="block text-sm font-medium text-white/80 mb-2">Message</label>
                                        <textarea
                                            id="message"
                                            required
                                            rows={4}
                                            className="w-full bg-black/40 border border-white/10 rounded-lg px-4 py-3 text-white placeholder-white/30 focus:outline-none focus:border-premium-gold transition-colors resize-none"
                                            placeholder="How can we help you?"
                                            value={formData.message}
                                            onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                                        ></textarea>
                                    </div>
                                    <button
                                        type="submit"
                                        className="w-full bg-gradient-to-r from-premium-gold-dark to-premium-gold text-premium-wood-dark font-bold py-3rounded-lg shadow-[0_0_20px_rgba(212,175,55,0.3)] hover:shadow-[0_0_30px_rgba(212,175,55,0.5)] transition-all transform hover:-translate-y-0.5"
                                    >
                                        Send Message
                                    </button>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default ContactUs;
